import React from "react";
import { memberPhoto } from "../config/images";

/**
 * MemberCard
 * Props:
 *  - member: { name, role, bio, image, email, linkedin }
 */
function MemberCard({ member }) {
  return (
    <div className="card apk-card text-center p-4 h-100">
      <img
        src={memberPhoto(member.image)}
        alt={member.name}
        className="member-photo mx-auto mb-3"
      />
      <h5 className="fw-bold text-navy mb-0">{member.name}</h5>
      <p className="text-orange fw-semibold small mb-2">{member.role}</p>
      <p className="text-secondary small mb-3">{member.bio}</p>
      <div className="d-flex justify-content-center gap-3 mt-auto">
        {member.email && (
          <a href={`mailto:${member.email}`} aria-label={`Email ${member.name}`} className="text-navy fs-5">
            <i className="bi bi-envelope-fill"></i>
          </a>
        )}
        {member.linkedin && (
          <a href={member.linkedin} target="_blank" rel="noreferrer" aria-label={`${member.name} on LinkedIn`} className="text-navy fs-5">
            <i className="bi bi-linkedin"></i>
          </a>
        )}
      </div>
    </div>
  );
}

export default MemberCard;
